import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';


const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const productStockManagementSlice = createSlice({
    name: 'productStockManagement',
    initialState,
    reducers: {
        funGetProductStockManagement(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map((productStockManagement ) =>{
                return{
                    ...productStockManagement,
                    devDt: m.date({ value: productStockManagement.devDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const productStockManagementActions = productStockManagementSlice.actions;
export default productStockManagementSlice.reducer;